import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSWRConfig } from 'swr'
import { toast } from 'sonner'
import { authApi } from '../api'

export function useLogout() {
  const { mutate } = useSWRConfig()
  const navigate = useNavigate()

  return useCallback(async () => {
    const result = await authApi.logout()

    if (!result.success) {
      toast.error(result.error)
      return
    }

    mutate(() => true, undefined, { revalidate: false })
    navigate('/login', { replace: true })
  }, [mutate, navigate])
}
